import * as React from "react";
import { useEffect, useState, useRef } from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Button, IconButton, Fade, TablePagination } from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import ModalAddProjectDescription from "./ModalAddProjectDescription";
import ModalEditProjectDescription from "./ModalEditProjectDescription";
import {
  GetIdProjectDescription,
  GetListProjectDescription,
  PostListProjectDescription,
  getDescriptionMonthDec,
  copyDescriptionDes,
  ImportDataDescription,
  ExportProjectDescription
} from "../../api/APIProjectDescription";
import { ExportDataDescription } from "../../constants";
import { GetListProject } from "../../api/listProject";
import { GridLoader } from "react-spinners";
import { Input, Spin } from "antd";
import { SearchOutlined } from "@mui/icons-material";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";
import { GetIdCurrencyEditApi } from "../../api/listCurrencyDescription";
import ModalMoneyDateDescription from "./ModalMoneyDateDescription";
import CreateNewIcon from "../../components/icons/CreateNewIcon";
import EditIcon from "../../components/icons/EditIcon";
import LockRedIcon from "../../components/icons/LockRedIcon";
import MoneyDateIcon from "../../components/icons/MoneyDateIcon";
import LockGreenIcon from "../../components/icons/LockGreenIcon";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { LoadingButton } from "@mui/lab";
import ResultImportModal from "./ResultImportModal";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
  verticalAlign: 'top', // Thêm CSS vertical-align: top
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(246, 246, 252, 1)",
    color: "rgba(59, 66, 95, 1)",
    fontSize: 16,
    fontWeight: 700,
    height: 60,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

//CSS ToolTip
const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} placement="top" />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    boxShadow: theme.shadows[1],
    fontSize: 14,
  },
}));

const columns = [
  {
    id: "Search key",
    label: "Search key",
    align: "center",
  },
  {
    id: "Client Code",
    label: "Client Code",
    align: "center",
  },
  {
    id: "Project Name",
    label: "Project Name",
    align: "center",
  },
  {
    id: "Project Stage",
    label: "Project Stage",
    align: "center",
  },
  {
    id: "Sub-project Name 1",
    label: "Sub-project Name 1",
    align: "center",
  },
  {
    id: "Sub-project Name 2",
    label: "Sub-project Name 2",
    align: "center",
  },
  {
    id: "Project Description",
    label: "Project Description",
    align: "center",
  },
  {
    id: "Pricing models",
    label: "Pricing models",
    align: "center",
  },
  {
    id: "Unit price Total",
    label: "Unit price Total",
    align: "right",
  },
  {
    id: "RSVN to RSJP",
    label: "RSVN to RSJP",
    align: "center",
  },
  {
    id: "RSVN to RSJP Unit price",
    label: "RSVN to RSJP Unit price",
    align: "right",
  },
  {
    id: "actions",
    label: "Action",
    align: "center",
  },
];

const ProjectDescription = () => {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [ListValueProjectDescription, setListValueProjectDescription] = useState([]);
  const [ListValueProject, setIsListValueProject] = useState([]);
  const [isModalOpenEditProject, setIsModalOpenEditProject] = useState(false);
  const [isModalOpenAddProject, setIsModalOpenAddProject] = useState(false);
  const [idEditProject, setIdEditProject] = useState(null);
  const [dataInforProject, setDataInforProject] = useState([]);
  const [loading, setLoading] = useState(true);
  const [valueSearch, setValueSearch] = useState([]);
  const [checkValueSearch, setCheckValueSearch] = useState();
  const screenWindown = window.screen.width <= 1550;
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonCheck, setLoadingButtonCheck] = useState(false);

  const [idEditCurrency, setIdEditCurrency] = useState(null);
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const [isModalOpenMoneyDate, setIsModalOpenMoneyDate] = useState(false);
  const [dataMoneyDate, setDataMoneyDate] = useState([]);

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  // Show/Hide Button Copy data Description
  const [showButtonCopy, setShowButtonCopy] = useState(true);

  const inputRef = useRef();

  // Import file
  const [loadingImport, setLoadingImport] = useState(false);

  const [isModalResultImport, setIsModalResultImport] = useState(false);
  const [resultImport, setresultImport] = useState([]); // Danh sách lỗi từ API

  // Export file
  const [loadingExportFile, setLoadingExportFile] = useState(false);

  const fetchDataProjectDescription = (e) => {
    if (e === "lockProject") {
      setLoadingButton(true);
    } else if (e === "checkProject") {
      setLoadingButtonCheck(true);
    }
    GetListProjectDescription()
      .then((res) => {
        setListValueProjectDescription(res.data.message);
        setLoading(false);
        setLoadingButton(false);
        setLoadingButtonCheck(false);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingButton(false);
        setLoadingButtonCheck(false);
      });
  };

  const fetchDataProject = (e) => {
    GetListProject()
      .then((res) => {
        setIsListValueProject(res.data.data);
        setLoading(false);
        setLoadingButton(false);
        setLoadingButtonCheck(false);
      })
      .catch((err) => {
        setLoading(false);
        setLoadingButton(false);
        setLoadingButtonCheck(false);
      });
  };

  const fetchCheckDescriptionDes = () => {
    getDescriptionMonthDec({ year: currentYear })
      .then((res) => {
        if (res.data?.result === false) {
          setShowButtonCopy(false); // Hiển thị button Copy
        } else {
          setShowButtonCopy(true); // Ẩn button Copy
        }
      })
      .catch((error) => {
        console.log("Error fetch data: ", error);
        setShowButtonCopy(false);
      })
  }

  useEffect(() => {
    setLoading(true);
    fetchDataProjectDescription();
    fetchDataProject();
    fetchCheckDescriptionDes()
  }, []);

  const handleCopyDescription = () => {
    setLoadingButton(true);
    copyDescriptionDes({ year: currentYear })
      .then((res) => {
        if (res.data?.message === 'ok') {
          ToastSuccess.fire({
            icon: "success",
            title: "Copy Description thành công",
          });
          // Ẩn lại button Copy sau khi Copy dữ liệu thành công
          setShowButtonCopy(true);
        } else {
          ToastSuccess.fire({
            icon: "error",
            title: "Copy Description thất bại",
          });
        }
      })
      .catch((err) => {
        ToastSuccess.fire({
          icon: "error",
          title: "Mở khóa Description thất bại",
        });
      });
    setLoadingButton(false);

  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const showModalAddProject = () => {
    setIsModalOpenAddProject(true);
  };

  const handleOkAddProject = () => {
    setIsModalOpenAddProject(false);
  };

  const showModalEditProjectDescription = (e) => {
    // console.log('id:', e.id);

    setIdEditProject(e.id);
    GetIdProjectDescription({ id: e.id })
      .then((re) => {
        setDataInforProject(re.data.message);
        setIsModalOpenEditProject(true);
      })
      .catch((err) => {
        ToastError.fire({
          icon: "error",
          title: `Lỗi status ${err.status}`,
        });
      });
  };

  const handleOkEditProject = () => {
    setIsModalOpenEditProject(false);
  };

  const handleSearchPS = (e) => {
    const keyword = e.target.value.toUpperCase();
    setCheckValueSearch(e.target.value);
    const valueSS = ListValueProjectDescription
      .filter(
        (value) =>
          value.description_code.toUpperCase().includes(keyword) ||
          value.project_code__client__client_code.toUpperCase().includes(keyword) ||
          value.project_code__project_name.toUpperCase().includes(keyword) ||
          value.projectstage.toUpperCase().includes(keyword) ||
          value.subprojectname1.toUpperCase().includes(keyword) ||
          value.subprojectname2.toUpperCase().includes(keyword) ||
          value.projectcription.toUpperCase().includes(keyword)
      )
      .map((item) => {
        return item;
      });
    setPage(0);
    setValueSearch(valueSS);
  };

  const handleClickLock = (e) => {
    var FormData = require("form-data");
    var data = new FormData();
    const valueLockProject = "lockProject";
    data.append("message", "lock");
    data.append("id", e.id);
    PostListProjectDescription(data)
      .then((res) => {
        // Cập nhật trạng thái lock trong danh sách
        const updatedList = valueSearch.map((project) => {
          if (project.id === e.id) {
            return { ...project, is_active: !project.is_active }; // Đảo trạng thái lock
          }
          return project;
        });

        // Gán lại danh sách để render
        setValueSearch(updatedList);

        if (e.is_active === true) {
          ToastSuccess.fire({
            icon: "success",
            title: "Khóa Description thành công",
          });
        } else {
          ToastSuccess.fire({
            icon: "success",
            title: "Mở khóa Description thành công",
          });
        }
        fetchDataProjectDescription(valueLockProject);
      })
      .catch((error) => {
        ToastError.fire({
          icon: "error",
          title: error.data.message,
        });
      });
  };

  const handleOkMoneyDate = () => {
    setIsModalOpenMoneyDate(false);
  };

  const showModalMoneyDate = (e) => {
    setIdEditCurrency(e.id);
    let dateCurrent = new Date().getFullYear();
    setCurrentYear(dateCurrent);
    GetIdCurrencyEditApi({ id: e.id, year: dateCurrent })
      .then((re) => {
        setDataMoneyDate(re.data.message);
        setIsModalOpenMoneyDate(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const clearFile = () => {
    var input = document.getElementById("myFile");
    input.value = "";
  };

  const isXlsxFile = (file) => {
    if (file !== undefined) {
      const fileType = file.type;
      const validTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        // Add more valid xlsx MIME types here if needed
      ];
      return validTypes.includes(fileType);
    }
  };

  const handleImport = ($event) => {
    setLoadingImport(true);
    const file = $event.target.files[0];
    if (!isXlsxFile(file)) {
      ToastError.fire({
        icon: "error",
        title: "Please select a valid .xlsx file.",
      });
      return;
    } else {
      var FormData = require("form-data");
      var data = new FormData();
      data.append("file", inputRef.current.files[0]);

      ImportDataDescription(data)
        .then((res) => {
          const resultImport = res.data?.message;
          console.log('resultImport: ', resultImport);
          // Cập nhật danh sách message và mở Modal
          setresultImport(resultImport); // Lưu danh sách message
          setIsModalResultImport(true); // Mở modal

          setLoadingImport(false);
          fetchDataProjectDescription();
          fetchDataProject();
          clearFile();
        })

        .catch((error) => {
          ToastError.fire({
            icon: "error",
            title: error.data?.message || "Upload thất bại"
          });
          setLoadingImport(false);
          clearFile();
        });
    }
  };

  const HandleExportFile = () => {
    setLoadingExportFile(true);
    ExportProjectDescription()
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = `${ExportDataDescription}`;
        // link.href = url;
        // link.setAttribute("download", "dttt.xlsx"); // Set the desired file name and extension
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Clean up the temporary URL and link
        URL.revokeObjectURL(url);
        setLoadingExportFile(false);

        document.body.removeChild(link);
      })
      .catch((err) => {
        setLoadingExportFile(false);
      });
  };

  // Hàm tiện ích hiển thị từng ô dữ liệu
  const renderCell = (content, align, key) => (
    <StyledTableCell align={align} key={key}>
      <Tooltip
        className="tooltipProject"
        title={content}
        placement="top-end"
      >
        <p className="dien-giai-hoaDon">{content}</p>
      </Tooltip>
    </StyledTableCell>
  );

  return (
    <>
      <Box sx={
        screenWindown === true
          ? { width: "96%", margin: "1% auto", }
          : { width: "96%", margin: "2% auto", }
      }
      >
        <Box sx={
          screenWindown === true
            ? { float: "left", marginBottom: "1%" }
            : { float: "left", marginBottom: "2%" }
        }
        >
          <Input
            placeholder="Search..."
            suffix={<SearchOutlined />}
            size="large"
            onChange={handleSearchPS}
          />
        </Box>

        <Box sx={
          screenWindown === true
            ? { float: "right", marginBottom: "1%" }
            : { float: "right", marginBottom: "2%" }
        }
        >
          <Button
            className="setSizeButton"
            variant="outlined"
            style={{
              fontSize: "14px",
              color: "#fff",
              background: "rgba(51, 122, 238, 1)",
              borderColor: "rgba(51, 122, 238, 1)",
              marginLeft: "10px",
            }}
            onClick={HandleExportFile}
          disabled={loadingExportFile}
          >
            Export
            <IconButton>
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.24316 11.2891L9.0315 8.5L6.24316 5.71094"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M1.59375 8.5H9.02929"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M9.03125 2.65625H12.75C12.8909 2.65625 13.026 2.71222 13.1257 2.81185C13.2253 2.91148 13.2812 3.0466 13.2812 3.1875V13.8125C13.2812 13.9534 13.2253 14.0885 13.1257 14.1882C13.026 14.2878 12.8909 14.3438 12.75 14.3438H9.03125"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </IconButton>
          </Button>

          <input
            accept=".xlsx"
            type="file"
            onChange={handleImport}
            ref={inputRef}
            id="myFile"
            name="myFile"
            style={{ display: "none" }}
          />
          <LoadingButton
            className="setSizeButton"
            variant="outlined"
            htmlFor="myFile"
            component="label"
            loading={loadingImport}
            style={{
              fontSize: "14px",
              color: "#fff",
              background: "rgba(84, 101, 239, 1)",
              borderColor: "rgba(84, 101, 239, 1)",
              marginLeft: "10px",
              padding: "7px 20px",
            }}
            endIcon={
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.83984 11.5586L10.0937 13.8125L12.3476 11.5586"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M10.0938 8.5V13.8125"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.37431 13.8125H4.78056C4.25319 13.812 3.73196 13.6993 3.25146 13.4819C2.77096 13.2646 2.34219 12.9475 1.99361 12.5518C1.64503 12.156 1.38461 11.6907 1.22963 11.1866C1.07465 10.6825 1.02866 10.1512 1.09471 9.62798C1.16077 9.10476 1.33735 8.60157 1.61275 8.15181C1.88814 7.70206 2.25605 7.31602 2.69205 7.01932C3.12805 6.72263 3.62217 6.52206 4.14161 6.43094C4.66105 6.33981 5.19393 6.36021 5.70489 6.49078"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.3125 8.49997C5.31258 7.65823 5.51268 6.82855 5.8963 6.07931C6.27993 5.33007 6.8361 4.68271 7.51899 4.19058C8.20187 3.69844 8.99193 3.37562 9.82405 3.24871C10.6562 3.12181 11.5065 3.19445 12.3051 3.46065C13.1036 3.72685 13.8275 4.17899 14.417 4.77982C15.0065 5.38064 15.4448 6.11295 15.6958 6.91641C15.9468 7.71986 16.0033 8.57145 15.8606 9.40101C15.7179 10.2306 15.3802 11.0144 14.8752 11.6878"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            }
          >
            Import
          </LoadingButton>

          {!showButtonCopy && (
            <Button
              className="setSizeButton"
              variant="outlined"
              style={{
                fontSize: "14px",
                color: "#fff",
                background: "rgba(51, 122, 238, 1)",
                borderColor: "rgba(51, 122, 238, 1)",
                marginLeft: "10px",
              }}
              onClick={handleCopyDescription}
            >
              Copy
              <IconButton >
                <ContentCopyIcon />
              </IconButton>
            </Button>
          )

          }
          <Button
            className="setSizeButton"
            variant="outlined"
            style={{
              fontSize: "14px",
              color: "rgba(84, 101, 239, 1)",
              marginLeft: "10px",
              borderColor: "rgba(84, 101, 239, 1)",
            }}
            onClick={showModalAddProject}
          >
            Create New
            <IconButton>
              <CreateNewIcon />
            </IconButton>
          </Button>
        </Box>

        <Box>
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer
              component={Paper}
              sx={{ maxHeight: screenWindown ? 540 : 650 }}
            >
              <Table aria-label="sticky table" size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <StyledTableCell key={column.id} align={column.align}>
                        {column.label}
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {!loading && (
                  <TableBody>
                    {(
                      checkValueSearch && checkValueSearch.length > 0
                        ? valueSearch.slice(startIndex, endIndex)
                        : ListValueProjectDescription.slice(startIndex, endIndex)
                    ).map((row, index) => (
                      <StyledTableRow key={index}>
                        {renderCell(row.description_code, "center", "description_code")}
                        {renderCell(
                          row.project_code__client__client_code,
                          "center",
                          "client_code"
                        )}
                        {renderCell(
                          row.project_code__project_name,
                          "center",
                          "project_name"
                        )}
                        {renderCell(row.projectstage, "center", "project_stage")}
                        {renderCell(row.subprojectname1, "center", "subprojectname1")}
                        {renderCell(row.subprojectname2, "center", "subprojectname2")}
                        {renderCell(row.projectcription, "center", "project_description")}
                        {renderCell(row.pricingmodels, "center", "pricing_models")}
                        <StyledTableCell align="right">
                          {row.unit_price_total}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          {row.rsvn_to_rsjp ? "Yes" : "No"}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {row.rsvn_to_rsjp_unit_price}
                        </StyledTableCell>
                        <StyledTableCell align="center" style={{ display: "flex" }}>
                          <LightTooltip title="Chỉnh sửa">
                            <IconButton onClick={() => showModalEditProjectDescription(row)}>
                              <EditIcon />
                            </IconButton>
                          </LightTooltip>
                          <LightTooltip title={row.is_active ? "Khóa" : "Mở khóa"}>
                            <IconButton
                              onClick={() => handleClickLock(row)}
                              disabled={loadingButton}
                            >
                              {row.is_active ? <LockGreenIcon /> : <LockRedIcon />}
                            </IconButton>
                          </LightTooltip>
                          <LightTooltip title="Date">
                            <IconButton onClick={() => showModalMoneyDate(row)}>
                              <MoneyDateIcon />
                            </IconButton>
                          </LightTooltip>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
              {loading && (
                <Fade in={loading} unmountOnExit>
                  <div
                    style={{
                      width: "100%",
                      height: "50vh",
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      background: "#f5f5f5",
                    }}
                  >
                    <GridLoader color="#020f59" loading={true} size={10} />
                    <p style={{ fontSize: 20 }}>Loading...</p>
                  </div>
                </Fade>
              )}
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50, 100]}
              component="div"
              count={
                checkValueSearch && checkValueSearch.length > 0
                  ? valueSearch.length
                  : ListValueProjectDescription.length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </Box>

      </Box>    

      <ModalAddProjectDescription
        isModalOpenAddProject={isModalOpenAddProject}
        handleOkAddProject={handleOkAddProject}
        setIsModalOpenAddProject={setIsModalOpenAddProject}
        fetchDataProjectDescription={fetchDataProjectDescription}
        ListValueProject={ListValueProject}
      />

      <ModalEditProjectDescription
        isModalOpenEditProject={isModalOpenEditProject}
        handleOkEditProject={handleOkEditProject}
        setIsModalOpenEditProject={setIsModalOpenEditProject}
        fetchDataProjectDescription={fetchDataProjectDescription}
        ListValueProject={ListValueProject}
        idEditProject={idEditProject}
        dataInforProject={dataInforProject}
      />

      <ModalMoneyDateDescription
        isModalOpenMoneyDate={isModalOpenMoneyDate}
        handleOkMoneyDate={handleOkMoneyDate}
        setIsModalOpenMoneyDate={setIsModalOpenMoneyDate}
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        dataMoneyDate={dataMoneyDate}
        idEditCurrency={idEditCurrency}
        setDataMoneyDate={setDataMoneyDate}
      />

      <ResultImportModal
        visible={isModalResultImport}
        onClose={() => setIsModalResultImport(false)} // Đóng modal
        resultImport={resultImport} // Truyền danh sách
      />

    </>
  );
};

export default ProjectDescription;

